module.exports = __webpack_public_path__ + "img/img20.ec9d5407.png";